import React from 'react';
import '../styles/footer.css';

const Footer = () => {
  return (
    <footer className="text-footer text-white text-center py-3 fixed-bottom">
      <div className="container d-flex justify-content-between">
        <span className="footer-left">
          © 2026 Saber Comece. Todos os direitos reservados.
        </span>
        <a
          href="https://comecehub.com.br"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-right text-white text-decoration-none"
        >
          Desenvolvido por time de tecnologia Comece
        </a>
      </div>
    </footer>
  );
};

export default Footer;
